// @flow
import React from 'react';
import { withStyles } from '@mui/styles';
import PropTypes from 'prop-types';
import TextField from '@mui/material/TextField';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';
import FormGroup from '@mui/material/FormGroup';
import Typography from '@mui/material/Typography';
import MenuItem from '@mui/material/MenuItem';
import clsx from 'clsx';

const styles = (theme) => ({
  formControl: {
    padding: theme.spacing(2),
    position: 'relative',
    marginTop: 0,
    marginBottom: 0,
    boxSizing: 'border-box',
  },
  disablePadding: {
    padding: 0,
  },
  textField: {
    boxSizing: 'border-box',
    maxWidth: '100%',
  },
  title: {
    fontSize: '1.25rem',
    fontWeight: 'bold',
  },
  label: {
    fontSize: '1rem',
  },
  '@media (max-width: 1024px), (max-height: 800px)': {
    title: {
      fontSize: '1rem',
    },
    label: {
      fontSize: '0.75rem',
    },
  },
});

const SelectFormControl = (props) => {
  const { classes, className, disabled, disablePadding, 'data-testid': testId } = props;

  const rootClass = {
    [classes.formControl]: true,
    [classes.disablePadding]: disablePadding,
  };

  if (className) {
    rootClass[className] = true;
  }

  return (
    <FormControl
      component="fieldset"
      className={clsx(rootClass)}
      fullWidth={true}
      margin={'dense'}
      disabled={disabled}
    >
      {props.title && (
        <Typography className={classes.title} variant={'h6'}>
          {props.title}
        </Typography>
      )}
      <FormLabel component="label" className={classes.label}>
        {props.label}
      </FormLabel>
      <FormGroup aria-disabled={disabled}>
        <TextField
          id="outlined-select-metering"
          select={true}
          size="small"
          disabled={disabled}
          classes={{ root: classes.textField }}
          value={props.value}
          onChange={(event) => props.onChange(event.target.value)}
          slotProps={{
            select: {
              SelectDisplayProps: { 'data-testid': testId },
              inputProps: { 'data-testid': testId ? `${testId}-value` : undefined },
              MenuProps: { className: classes.menu },
            },
            input: { classes: { input: classes.menu } },
          }}
          margin="dense"
          helperText={props.helperText}
          variant="outlined"
        >
          {props.options
            ? props.options.map((option, idx) => (
                <MenuItem
                  key={`${idx}-${option.value}`}
                  data-testid={testId ? `${testId}-option-${option.value}` : undefined}
                  value={option.value}
                  disabled={option.disabled}
                >
                  {option.label}
                </MenuItem>
              ))
            : []}
        </TextField>
      </FormGroup>
    </FormControl>
  );
};

SelectFormControl.propTypes = {
  title: PropTypes.string,
  label: PropTypes.string.isRequired,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.any.isRequired,
      label: PropTypes.string.isRequired,
    })
  ),
  value: PropTypes.any.isRequired,
  onChange: PropTypes.func.isRequired,
  disablePadding: PropTypes.bool,
  helperText: PropTypes.string,
  'data-testid': PropTypes.string,
};

export default withStyles(styles)(SelectFormControl);
